import { render, staticRenderFns } from "./PreviewContentImage.vue?vue&type=template&id=54021e7e&scoped=true"
import script from "./PreviewContentImage.vue?vue&type=script&lang=js"
export * from "./PreviewContentImage.vue?vue&type=script&lang=js"
import style0 from "./PreviewContentImage.vue?vue&type=style&index=0&id=54021e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54021e7e",
  null
  
)

export default component.exports